'use client';
import { Col, Flex, Row } from 'antd';
import Heading from '@componentsHeading';
import { crossSellBannerData, withFullPath } from '@/utils/utils';
import PageImage from '@/components/PageImage';
import PageRow from '@/components/PageRow';
import PartyIntro from '@/components/PartyIntro';
import PartyCard from '@/components/PartyCard';
import PartyAlbum from '@/components/PartyAlbum';
import PartyVenue from '@/components/PartyVenue';
import { useGlobalStore } from '@/hooks/useGlobalStore';
import CrossSellBanner from '@/components/CrossSellBanner';
import { CrossSellBannerFragment } from '@/@types/generated/sitecore';
import { useEffect } from 'react';
import { WATrackerTrackPageView } from '@/utils/wa';
import useALTracker from '@/utils/useALTracker';

const withoutEnabled = [
    'PartyIntroBlock',
    'PartyCardBlock',
    'PartyAlbumBlock',
    'VenueBlock',
    'Image',
    'Row',
];

const components: any = {
    PartyIntroBlock: PartyIntro,
    PartyCardBlock: PartyCard,
    PartyAlbumBlock: PartyAlbum,
    VenueBlock: PartyVenue,
    Image: PageImage,
    Row: PageRow,
};

const CurrentlyOn = (props: any) => {
    // console.log('detail----', props);
    const { ALTrackPageLoad } = useALTracker();
    const globalStore = useGlobalStore();
    const { partyInformation, partyDetail } = props.data;

    const defaultTheme = globalStore.globalSettingData?.masterColorCode?.targetItem;

    const currentTheme = {
        themeColor:
            partyInformation?.partyColorCode?.targetItem?.themeColorCode?.value ||
            defaultTheme?.themeColorCode?.value ||
            '',
        fontColor:
            partyInformation?.partyColorCode?.targetItem?.fontColor?.value ||
            defaultTheme?.fontColor?.value ||
            '',
        musicWaveColor:
            partyInformation?.partyColorCode?.targetItem?.musicWaveColor?.value ||
            defaultTheme?.musicWaveColor?.value ||
            '',
        buttonBGColor:
            partyInformation?.partyColorCode?.targetItem?.buttonBGColor?.value ||
            defaultTheme?.buttonBGColor?.value ||
            '',
        overlayBGColor:
            partyInformation?.partyColorCode?.targetItem?.overlayBGColor?.value ||
            defaultTheme?.overlayBGColor?.value ||
            '',
        primaryButtonBGColor:
            partyInformation?.partyColorCode?.targetItem?.primaryButtonBGColor?.value ||
            defaultTheme?.primaryButtonBGColor?.value ||
            '',
        primaryButtonIconColor:
            partyInformation?.partyColorCode?.targetItem?.primaryButtonIconColor?.value ||
            defaultTheme?.primaryButtonIconColor?.value ||
            '',
        secondaryButtonBGColor:
            partyInformation?.partyColorCode?.targetItem?.secondaryButtonBGColor?.value ||
            defaultTheme?.secondaryButtonBGColor?.value ||
            '',
        secondaryButtonIconColor:
            partyInformation?.partyColorCode?.targetItem?.secondaryButtonIconColor?.value ||
            defaultTheme?.secondaryButtonIconColor?.value ||
            '',
        highlightColor:
            partyInformation?.partyColorCode?.targetItem?.highlightColor?.value ||
            defaultTheme?.highlightColor?.value ||
            '',
        h2Color:
            partyInformation?.partyColorCode?.targetItem?.h2Color?.value ||
            defaultTheme?.h2Color?.value ||
            '',
    };

    const crossSellBannerObj: CrossSellBannerFragment[] = crossSellBannerData(
        props.data.partyDetail,
    );

    const getCludesName: any = (all: string[], templateName: string) => {
        const getVal = Array.from(all).filter((i) => templateName === i);
        return getVal[0] || '';
    };

    useEffect(() => {
        globalStore.setGlobalStore({
            pageID: `parties/${partyInformation?.partyName?.value || 'Detail'}`,
        });
        globalStore.setCurrentTheme(currentTheme);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [partyInformation?.partyName?.value, globalStore.lang]);

    useEffect(() => {
        ALTrackPageLoad(`RnE/HW/Party/${partyInformation?.partyName?.value || 'Detail'}`);
    }, [partyInformation?.partyName?.value]);

    return (
        <>
            {/* 头部 */}
            <Flex
                style={{ backgroundImage: `url(${withFullPath(partyDetail?.headerBgImage?.src)})` }}
                align='center'
                justify='center'
                className='relative bg-cover bg-no-repeat bg-center w-full max-w-[1920px]'
            >
                <div
                    className={'absolute top-0 left-0 right-0 bottom-0'}
                    style={{
                        backgroundColor: 'rgba(5, 25, 64, 0.80)',
                    }}
                ></div>
                <div className={'max-w-[1920px] min-h-[300px] z-[1] w-full px-5 xmd:px-20'}>
                    <Flex
                        vertical
                        gap={16}
                        align='center'
                        className='xmd:pt-[150px] max-xmd:mt-28 max-xmd:mb-10'
                    >
                        <Heading
                            className='!text-base-font-color'
                            level={2}
                            text={partyInformation?.partyName?.value}
                        />
                        <Heading
                            className=' text-black w-fit h-[26px] !leading-[26px]'
                            level={5}
                            text={partyInformation?.partyDateText?.value}
                            style={{
                                color: currentTheme.fontColor,
                                backgroundColor: currentTheme.highlightColor,
                            }}
                        />
                    </Flex>
                </div>
            </Flex>

            <>
                {partyDetail?.row?.map((row: any) => (
                    <div key={row.name}>
                        {row.col?.length === 1 && (
                            <Flex
                                justify='center'
                                align='center'
                                className={'bg-primary-bg-color max-w-[1920px] w-full'}
                            >
                                {row.col?.map((col: any, num: number) => (
                                    <div key={num} className='w-full'>
                                        {col.pageContent?.map((content: any, index: number) => {
                                            const templateName =
                                                content?.template?.name || 'default';
                                            const cludesName = getCludesName(
                                                withoutEnabled,
                                                templateName,
                                            );
                                            const enabled = templateName.includes(cludesName);
                                            const Component = components[cludesName];
                                            content.rowPageEventID =
                                                'Party_PlanYourVisits' || 'Detail';
                                            content.rowSecondPageEventID = 'Party_FAQ' || 'Detail';
                                            // content.rowPageEventID = `Party/Detail_${partyInformation?.partyName?.value || 'Detail'}`;
                                            // content.rowClickEventID = `RnE/HW_ClickBanner_Party-${partyInformation?.partyName?.value || 'Detail'}`;
                                            return enabled && Component ? (
                                                <div key={index}>
                                                    <Component
                                                        content={content}
                                                        data={props.data}
                                                    />
                                                </div>
                                            ) : (
                                                ''
                                            );
                                        })}
                                    </div>
                                ))}
                            </Flex>
                        )}
                        {row.col?.length === 2 && (
                            <Flex
                                vertical
                                justify={'center'}
                                align={'center'}
                                className={'bg-primary-bg-color xmd:py-[91px] max-xmd:pb-[64px]'}
                            >
                                <Row align={'middle'} className={'max-w-[1920px]'}>
                                    {row.col?.map((col: any, index: number) => (
                                        <Col
                                            className={`${index === 1 && 'xmd:pl-[60px]'}`}
                                            key={col.name}
                                            xs={24}
                                            lg={12}
                                        >
                                            {col.pageContent?.map((content: any, index: number) => {
                                                const templateName =
                                                    content?.template?.name || 'default';
                                                const cludesName = getCludesName(
                                                    withoutEnabled,
                                                    templateName,
                                                );
                                                const enabled = templateName.includes(cludesName);
                                                const Component = components[cludesName];
                                                content.rowPageEventID =
                                                    'Party_PlanYourVisits' || 'Detail';
                                                content.rowSecondPageEventID =
                                                    'Party_FAQ' || 'Detail';
                                                // content.rowPageEventID = `Party/Detail_${partyInformation?.partyName?.value || 'Detail'}`;
                                                // content.rowClickEventID = `RnE/HW_ClickBanner_Party-${partyInformation?.partyName?.value || 'Detail'}`;
                                                return enabled && Component ? (
                                                    <div key={index}>
                                                        <Component
                                                            content={content}
                                                            data={props.data}
                                                        />
                                                    </div>
                                                ) : (
                                                    ''
                                                );
                                            })}
                                        </Col>
                                    ))}
                                </Row>
                            </Flex>
                        )}
                    </div>
                ))}
            </>

            {/* footer */}
            {crossSellBannerObj?.length > 0 && <CrossSellBanner content={crossSellBannerObj[0]} />}
        </>
    );
};

export default CurrentlyOn;
